@if (forsorjningsKallaAggregat.typ === forsorjningskallaTyp.Leverantorsorder) {
  <div>
    <a [routerLink]="['leverantorsorder',forsorjningsKallaAggregat.leverantorsorderId]" container="body">
      {{getShortNamn()}}
    </a>
    <div>
      <span>{{forsorjningsKallaAggregat.huvudkod}}</span>
    </div>
  </div>
}
@if (forsorjningsKallaAggregat.typ === forsorjningskallaTyp.Terminal) {
  <div>
    {{forsorjningsKallaAggregat.namn}}
  </div>
}
@if (forsorjningsKallaAggregat.typ === forsorjningskallaTyp.Produktionsomrade) {
  <div>
    <div>{{forsorjningsKallaAggregat.namn}}</div>
    @if (!kundorderradAggregat.manuellPaArbetsorder) {
      <rask-checkbox
        aid="fKallaManuellPaAo"
        text="Manuell på AO"
        class="low ps-0"
        (change)="updateCommand($event)"
        [(ngModel)]="forsorjningsKallaAggregat.manuellPaArbetsorder"
        [disabled]="!canEdit">
      </rask-checkbox>
    }
  </div>
}